export default __webpack_public_path__ + "static/media/S_B_False.bfbd91dc.jpg";